"use client";

import { Card, CardContent } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Droplets, Sun, Shield, House, Wind, Footprints } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SeznamSluzeb() {
  const services = [{
    id: 1,
    title: "Fotovoltaika",
    description: "Kompletní realizace fotovoltaických systémů na klíč s dlouhodobou zárukou a prokazatelnou návratností investice.",
    icon: Sun,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/photovoltaic_solar_panel_detail.png"
  }, {
    id: 2,
    title: "Vysokotlaké čištění střech",
    description: "Odstranění mechu, lišejníků a nečistot pomocí profesionální vysokotlaké techniky bez poškození povrchu.",
    icon: Droplets,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/high_pressure_roof_cleaning_action.png"
  }, {
    id: 3,
    title: "Technologická impregnace",
    description: "Hydrofobní ochrana povrchů zajišťující dlouhodobou odolnost proti vodě, mrazu a biologickému napadení.",
    icon: Shield,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/hydrophobic_coating_application.png"
  }, {
    id: 4,
    title: "Čištění fasád",
    description: "Profesionální odstranění znečištění z fasád budov s ohledem na materiál a historickou hodnotu objektu.",
    icon: House,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/building_facade_cleaning_process.png"
  }, {
    id: 5,
    title: "Čištění okapů",
    description: "Komplexní čištění okapových systémů zajišťující správný odvod vody a prevenci poškození stavby.",
    icon: Wind,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/gutter_cleaning_maintenance.png"
  }, {
    id: 6,
    title: "Čištění chodníků",
    description: "Důkladné čištění venkovních zpevněných ploch s obnovením původního vzhledu a zvýšením bezpečnosti.",
    icon: Footprints,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/pavement_pressure_washing.png"
  }];
  const {
    ref: ref1,
    isVisible: visible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: ref2,
    isVisible: visible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: ref3,
    isVisible: visible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: ref4,
    isVisible: visible4
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: ref5,
    isVisible: visible5
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: ref6,
    isVisible: visible6
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const refs = [ref1, ref2, ref3, ref4, ref5, ref6];
  const visibilities = [visible1, visible2, visible3, visible4, visible5, visible6];
  return <section id="seznam-služeb" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-4">
            Naše služby
          </h2>
          <p className="text-muted-foreground text-lg sm:text-xl max-w-3xl mx-auto">
            Komplexní péče o váš majetek s technickou precizností a prokazatelnými výsledky
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={service.id} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <HoverCard openDelay={200} closeDelay={100}>
                  <HoverCardTrigger asChild>
                    <Card className="group relative h-80 overflow-hidden cursor-pointer transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.02] hover:shadow-strong border-border">
                      <div className="absolute inset-0 bg-cover bg-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" style={{
                    backgroundImage: `url(${service.image})`,
                    filter: "brightness(0.6) contrast(1.1)"
                  }} />
                      <div className="absolute inset-0 bg-gradient-to-t from-secondary-dark via-secondary-dark/60 to-transparent" />
                      
                      <CardContent className="relative h-full flex flex-col justify-end p-6 z-10">
                        <div className="mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]">
                          <Icon className="w-12 h-12 text-primary stroke-[1.5]" />
                        </div>
                        <h3 className="font-display text-2xl font-bold text-foreground mb-2 tracking-tight">
                          {service.title}
                        </h3>
                      </CardContent>
                    </Card>
                  </HoverCardTrigger>

                  <HoverCardContent side="top" align="center" className="w-80 bg-secondary-dark/95 backdrop-blur-md border-primary/20 shadow-strong">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0">
                        <Icon className="w-8 h-8 text-primary stroke-[1.5]" />
                      </div>
                      <div>
                        <h4 className="font-display text-lg font-semibold text-foreground mb-2">
                          {service.title}
                        </h4>
                        <p className="text-sm text-muted-foreground leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </HoverCardContent>
                </HoverCard>
              </div>;
        })}
        </div>
      </div>
    </section>;
}